import { render, staticRenderFns } from "./molecule.ugcAlmostDone.vue?vue&type=template&id=2064ac62"
import script from "./molecule.ugcAlmostDone.vue?vue&type=script&lang=ts"
export * from "./molecule.ugcAlmostDone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports